import {
  Box,
  Divider,
  Drawer,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Close } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { AddTopicsFormSchema } from "../../../forms-schema/form.schema";
import Scrollbar from "../../../components/scrollbar/Scrollbar";

import { useCreateTopicsMutation } from "../../../redux/services/topics.service";

export default function AddTopics({ open, onClose }) {
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(AddTopicsFormSchema),
  });

  // Reset the Errors and FormFields when open or closed the Form drawer
  useEffect(() => {
    reset();
  }, [open, reset]);

  const [createTopic, { isLoading }] = useCreateTopicsMutation();

  const handleClick = async (values) => {
    setLoading(true);
    try {
      const resultAction = await createTopic({
        ...values,
      });

      if (resultAction?.data?.success) {
        reset();
        onClose();
      }
    } catch (error) {
      // Catch and handle any errors during the process
      console.error("Error!! Pushing Notification:", error);

      // Display error using notistack
      enqueueSnackbar("ERROR!! Pushing Notification.", {
        variant: "error", // Set the snackbar type to 'error'
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    } finally {
      setLoading(false); // Ensure loading state is turned off in all cases
    }
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: { width: 360, border: "none", overflow: "hidden" },
        }}
      >
        <Scrollbar>
          <Stack spacing={3} sx={{ p: 3 }}>
            <div>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 0.5,
                }}
              >
                <Typography variant="subtitle1">Create Topic</Typography>
                <IconButton onClick={onClose}>
                  <Close />
                </IconButton>
              </Box>
              <Divider />
            </div>

            <Stack spacing={3}>
              <TextField
                name="name"
                type="string"
                label={
                  <>
                    Name <span style={{ color: "red" }}>*</span>{" "}
                    {/* Adding red star */}
                  </>
                }
                {...register("name", { required: true })}
                error={Boolean(errors.name)}
                helperText={errors.name && errors.name.message} // Adjusted to properly show the error message
              />

              <LoadingButton
                loading={loading || isLoading}
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={handleSubmit(handleClick)}
              >
                Create
              </LoadingButton>
            </Stack>
          </Stack>
        </Scrollbar>
      </Drawer>
    </>
  );
}
